import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TenantMgmtListComponent } from './tenant-mgmt-list.component';
import { TenantMgmtListRoutingModule } from 'src/app/main/tenant-mgmt-list/tenant-mgmt-list-routing.module';
import { BreadcrumbModule } from '../../components/breadcrumb/breadcrumb.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { IconsModule } from '../../icons/icons.module';
import { TableModule } from 'src/app/table/table.module';
import { LeftSideNavigationModule } from 'src/app/layout/left-side-navigation/left-side-navigation.module';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {SidenavHeaderModule} from 'src/app/components/sidenav-header/sidenav-header.module';
import {MatDividerModule} from '@angular/material/divider';
import {MatTabsModule} from '@angular/material/tabs';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatCardModule} from '@angular/material/card';
import { MatSelectModule } from '@angular/material/select';
import { ToolbarModule } from 'src/app/layout/toolbar/toolbar.module';
import { PaginatorModule } from 'src/app/components/paginator/paginator.module';
import { WorkflowDiagramModule } from 'src/app/components/workflow-diagram/workflow-diagram.module';
import { TenantDetailsComponent } from './tenant-details/tenant-details.component';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
@NgModule({
  declarations: [
    TenantMgmtListComponent,
    TenantDetailsComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    BreadcrumbModule,
    TenantMgmtListRoutingModule,
    IconsModule,
    TableModule,
    LeftSideNavigationModule,
    MatProgressSpinnerModule,
    SidenavHeaderModule,
    MatDividerModule,
    MatTabsModule,
    MatExpansionModule,
    MatCardModule,
    MatSelectModule,
    ToolbarModule,
    PaginatorModule,
    WorkflowDiagramModule,
    NgxSkeletonLoaderModule
  ]
})
export class TenantMgmtListModule { }
